import api from '@/services/api'

export const calibrateUsers = async (nBoxId, data) => {
    return await api.post('n-box-calibrations', {
        n_box_id: nBoxId,
        users: data,
    })
}
